import CardIcons from './CardIcons';

export default CardIcons;
